import { IPass } from './payease.types';

export const cx = (...classes: Array<string | false | null | undefined>): string => classes.filter(Boolean).join(' ');

export const formatPrice = (value: number): string => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);

export const passHasOptions = (pass: IPass): boolean => pass.options.length > 1;

export const passFromPrice = (pass: IPass): number => (pass.options.length ? Math.min(...pass.options.map((option) => option.price)) : 0);
